<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          class="mr-8"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />

        <avs-createButton
          :spantext="$t('actions.add', { entity: $tc('categories.pcqdsi.name', 1) })"
          menu
          :name="$t('actions.new', { entity: $tc('categories.pcqdsi.name', 1) })"
          @click="handleOpenEditDialog()"
        >
        </avs-createButton>
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        dense
        :headers="headers"
        :no-data-text="$t('messages.information.no_data')"
        :items="items"
        :items-per-page="-1"
        :search="search"
        item-key="id"
        @dblclick:row="
          ($event, { item }) => {
            if (allow.duplicate(item)) {
              handleOpenEditDialog(item)
            }
          }
        "
      >
        <template #item.description="{ item }">
          <span v-html="truncateText(item.description, 50)"></span>
        </template>
        <template #item.created_at="{ item }">
          {{ toDatetime(item.created_at) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <avs-editButton
              @click.stop="handleOpenEditDialog(item)"
              :disabled="item.validated"
              :spantext="$t('actions.edit', { entity: $t('commons.fieldtype').toLowerCase() })"
            />
            <avs-button
              icon
              color="secondary"
              :iconI="'mdi-eye'"
              label
              fab
              small
              @click.stop="showPcqDsis(item)"
              :spantext="$t('actions.open', { entity: $t('commons.fieldtype').toLowerCase() })"
            />

            <!-- <avs-button
              icon
              color="secondary"
              :iconI="'mdi-content-duplicate'"
              label
              fab
              small
              @click.stop="duplicatePcqDsis(item)"
              :spantext="
                $t('actions.duplicate', {
                  entity: $tc('categories.pcqdsi.name').toLowerCase()
                })
              "
            />

            <avs-button
              icon
              color="secondary"
              :iconI="'mdi-file-undo-outline'"
              label
              fab
              small
              @click.stop="revisePcqDsis(item)"
              :spantext="
                $t('actions.revise', {
                  entity: $tc('categories.pcqdsi.name').toLowerCase()
                })
              "
            /> -->

            <avs-button
              v-if="!loadingItems[item.id]?.duplicate"
              icon
              color="secondary"
              :iconI="'mdi-content-duplicate'"
              label
              fab
              small
              @click.stop="duplicatePcqDsis(item)"
              :spantext="
                $t('actions.duplicate', {
                  entity: $tc('categories.pcqdsi.name').toLowerCase()
                })
              "
            />
            <v-progress-circular
              v-else
              indeterminate
              color="secondary"
              small
            ></v-progress-circular>

            <avs-button
              v-if="!loadingItems[item.id]?.revise"
              icon
              color="secondary"
              :iconI="'mdi-file-undo-outline'"
              label
              fab
              small
              @click.stop="revisePcqDsis(item)"
              :spantext="
                $t('actions.revise', {
                  entity: $tc('categories.pcqdsi.name').toLowerCase()
                })
              "
            />
            <v-progress-circular
              v-else
              indeterminate
              color="secondary"
              small
            ></v-progress-circular>

            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :disabled="item.validated"
              :spantext="$t('actions.delete', { entity: $t('commons.fieldtype').toLowerCase() })"
            />
          </div>
        </template>
      </v-data-table>
      <!-- v-html="document.description" -->

      <v-dialog
        v-model="editDialogIsOpen"
        width="60vw"
      >
        <component
          v-model="selectedItem"
          :is="editDialogContent"
          :isEditable="isEditable"
          @cancel="handleCancel"
          @error="handleError"
          @success="handleSuccess"
        />
      </v-dialog>

      <DeleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="PCQ"
      />
    </template>
  </avs-card>
</template>

<script>
import { toDatetime } from "@/utils/datetime"
import { pcqLinerService } from "@/services"
// import { mkUnique } from "@/utils/validator"

import DeleteDialog from "@/components/generics/dialogs/DeleteDialog.vue"
import PcqEditor from "@/components/ri3/pcqDsi/PcqEditor.vue"

export default {
  name: "pcqLiner",
  components: { DeleteDialog, PcqEditor },
  created() {
    this.fetchFieldTypes()
  },
  computed: {
    project() {
      return this.$store.state.app.project
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("Revision"),
          value: "revision",
          // class: "min-width-150",
          sortable: true
        },
        {
          text: this.$t("commons.name"),
          value: "name",
          // class: "min-width-150",
          sortable: true
        },
        {
          text: this.$t("commons.description"),
          value: "description",
          sortable: true,
          filterable: false
        },
        {
          text: this.$t("commons.created_at"),
          value: "created_at",
          sortable: true,
          filterable: false
        },
        {
          text: this.$t("commons.action"),
          value: "actions",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      isEditable: true,
      items: [],
      search: "",
      loadingItems: {},
      // basecomponents: Object.values(COMPONENT_ENUM),
      deleteDialogIsOpen: false,
      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined
    }
  },
  methods: {
    toDatetime,
    fetchFieldTypes() {
      pcqLinerService
        .getAll(this, this.project.id)
        .then(response => {
          this.items = response.results
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
    },
    duplicatePcqDsis(item) {
      this.$set(this.loadingItems, item.id, { ...this.loadingItems[item.id], duplicate: true })
      pcqLinerService
        .duplicate(item.id)
        .then(response => {
          this.$store.commit("app/message", {
            msg: response.message,
            color: "success"
          })
          this.fetchFieldTypes()
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          this.$set(this.loadingItems, item.id, { ...this.loadingItems[item.id], duplicate: false })
        })
    },
    revisePcqDsis(item) {
      this.$set(this.loadingItems, item.id, { ...this.loadingItems[item.id], revise: true })
      pcqLinerService
        .revise(item.id)
        .then(response => {
          this.$store.commit("app/message", {
            msg: response.message,
            color: "success"
          })
          this.fetchFieldTypes()
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          this.$set(this.loadingItems, item.id, { ...this.loadingItems[item.id], revise: false })
        })
    },
    sum_users(users, externals) {
      return users.length + externals.length
    },
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) + "..." : text
    },
    showPcqDsis(item) {
      const redirect = this.$route.query.redirect || { name: "PcqDsis" }
      // this.$store.commit("app/clearPcqLiner")
      this.$store.commit("app/setPcqLiner", item)
      this.$router.push(redirect)
    },
    handleOpenDeleteDialog(item) {
      this.selectedItem = item
      this.deleteDialogIsOpen = true
    },
    handleOpenEditDialog(item) {
      this.selectedItem = undefined
      this.isEditable = true
      if (item) {
        this.selectedItem = item
        this.isEditable = true
      }
      this.handleOpenEditDialogByComponent()
    },
    handleOpenEditDialogByComponent() {
      this.editDialogIsOpen = true
      this.editDialogContent = "PcqEditor"
    },
    handleCancel() {
      this.selectedItem = undefined
      this.deleteDialogIsOpen = false
      this.editDialogIsOpen = false
      this.editDialogContent = null
    },
    handleError(message) {
      this.send(message || "Enter a valid email address.", "error")
    },
    handleSuccess() {
      this.handleCancel()
      this.$nextTick(() => {
        this.fetchFieldTypes()
        this.send(this.$t("messages.success.operation"), "success")
      })
    },
    handleDelete() {
      pcqLinerService
        .delete(this.selectedItem.id)
        .then(() => {
          this.handleSuccess()
        })
        .catch(error => {
          const message = error?.response.data?.state
          this.handleError(message)
        })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
